export const SHOW_MODAL_ADD_COIN = 'SHOW_MODAL_ADD_COIN';
export const SHOW_MODAL_TRANSACTION_CONFIRM = 'SHOW_MODAL_TRANSACTION_CONFIRM';
export const SHOW_MODAL_TRANSACTION_DETAILS = 'SHOW_MODAL_TRANSACTION_DETAILS';
export const SHOW_MODAL_TRANSACTION_STATUS = 'SHOW_MODAL_TRANSACTION_STATUS';
export const SHOW_MODAL_CLOSE_TOKEN_ACCOUNT = 'SHOW_MODAL_CLOSE_TOKEN_ACCOUNT';
export const SHOW_MODAL_ERROR = 'SHOW_MODAL_ERROR';
export const SHOW_MODAL_PROCEED_USERNAME = 'SHOW_MODAL_PROCEED_USERNAME';
